import React from "react";
import { useTranslation } from "react-i18next";
import TelegramIcon from "@mui/icons-material/Telegram";

// 1-QADAM: package.json faylini import qilamiz
// (Faylingiz qayerda joylashganiga qarab '../package.json' yoki '../../package.json' bo'lishi mumkin)
import packageInfo from "../../../package.json";

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  // 2-QADAM: Versiyani o'zgaruvchiga saqlaymiz
  const appVersion = packageInfo.version;

  return (
    <footer className="relative bg-slate-50 dark:bg-gray-950 border-t border-green-500/20 overflow-hidden transition-colors duration-300">
      <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-green-500 to-transparent opacity-70" />

      <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-slate-500 dark:text-slate-400">
        {/* Chap qism */}
        <div className="flex items-center text-center sm:text-left">
          <p>
            © {year}{" "}
            <span className="font-bold text-slate-700 dark:text-slate-200">
              MockTestlar
            </span>
            . {t("footer.title")}{" "}
            <a
              href="https://www.gayratjon.uz"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-500 hover:text-green-600 dark:hover:text-green-400 font-semibold hover:underline transition-colors ml-1"
            >
              G'ayratjon Abdijobborov
            </a>
          </p>
        </div>

        {/* O'ng qism */}
        <div className="flex items-center gap-4">
          {/* 3-QADAM: Versiyani shu yerga chiqaramiz */}
          <span className="font-medium px-2 py-1 bg-slate-200 dark:bg-slate-800 rounded-md text-xs">
            v{appVersion}
          </span>

          <div className="w-[1px] h-4 bg-slate-300 dark:bg-slate-700" />

          <div className="flex items-center">
            <a
              href="https://t.me/mocktestsuzbot"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 hover:text-green-500 transition-colors"
              title="Qo'llab-quvvatlash"
            >
              <TelegramIcon sx={{ fontSize: 18 }} />
              <span className="hidden sm:inline font-medium">Support</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
